import barba from '@barba/core';
import { Transitions } from './transitions';
import state from '../state';
import SmoothScroll from '../util/SmoothScroll';
import ModalLinks from '../util/ModalLinks';

const playVideos = () => {
  const vids = document.querySelectorAll('video');
  vids.forEach(vid => {
    const playPromise = vid.play();
    if (playPromise !== undefined) {
      playPromise
        .then(_ => {})
        .catch(error => {
          console.log(error);
        });
    }
  });
};
export function go(url) {
  barba.go(url);
}
export function initBarba() {
  barba.init({
    timeout: 5000,
    transitions: Transitions,
    debug: false,
    prevent: ({ el }) =>
      (el.classList && el.classList.contains('prevent')) ||
      el.href.includes('?modal='),
  });
  window.dispatchEvent(new Event('page:ready'));

  // Before everything.
  barba.hooks.before(data => {
    document.querySelector('html').classList.add('block-ui');
    state.smoothScroll.lenis.stop();

    const $menus = Array.from(document.querySelectorAll('.menu-item'));
    $menus.forEach(el => {
      const link = el.querySelector('a');
      if (link && link.href === data.trigger.href) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });
  });

  // Next page enter transition.
  barba.hooks.enter(data => {
    window.scrollTo(0, 0);
  });
  // After everything
  barba.hooks.after(() => {
    state.smoothScroll = new SmoothScroll();
    state.smoothScroll.init();
    state.modalLinks = new ModalLinks();
    state.modalLinks.init();
    window.dispatchEvent(new Event('page:ready'));
    playVideos();

    document.body.addEventListener(
      'Components/ready',
      () => {
        document.querySelector('html').classList.remove('block-ui');
      },
      { once: true }
    );

    // GA
    if (typeof window.gtag !== 'function') {
      return;
    }

    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: location.href,
      page_path: location.pathname,
    });
  });
}



//////////////////
// WEBPACK FOOTER
// ./scripts/barba/barba.js
// module id = 10
// module chunks = 0